import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hamburger",
  "use": "hamburger-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"hamburger\"><path d=\"M3 13h18a1 1 0 100-2H3a1 1 0 100 2zM3 7h18a1 1 0 100-2H3a1 1 0 000 2zM3 19h18a1 1 0 100-2H3a1 1 0 100 2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol